import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UnRx } from '@pebula/utils';

/**
 * A proxy to `Title` from `@angular/platform-browser` that add's a notifier.
 */
@Injectable()
@UnRx()
export class SgDocTitle {
  changed: Observable<string>;
  private changed$: BehaviorSubject<string>;

  constructor(private titleService: Title) {
    this.changed$ = new BehaviorSubject<string>(this.getTitle());
    this.changed = this.changed$.pipe(debounceTime(50), UnRx(this));
    this.changed.subscribe((newTitle) => this.titleService.setTitle(newTitle));
  }

  /**
   * Get the title of the current HTML document.
   */
  getTitle(): string {
    return this.titleService.getTitle();
  }

  /**
   * Set the title of the current HTML document.
   * @param newTitle
   */
  setTitle(newTitle: string): void {
    if (newTitle !== this.getTitle()) {
      this.changed$.next(newTitle);
    }
  }
}
